import React, { ReactNode, Suspense, useEffect, useState } from "react";
import { SharedProvider } from "../SharedContext";
import { WhiteLabelProvider } from "../WhiteLabelContext";
import { WhiteLabelLeadProvider } from "../WhiteLabelLeadContext";
import { PaymentProviderProvider } from "../PaymentProviderContext";
import { ToastContainer } from "react-toastify";
import { useTypedSelector } from "@lib/redux";
import { ROUTES } from "@lib/constants";
import { useNavigate } from "react-router-dom";
import { authorizedStructure } from "@app/.core/AppRoutes";
import { AppLoader } from "@lib/components/AppComponents";

type AppContextProviderProps = {
  children: ReactNode;
};

const AppContextProvider: React.FC<AppContextProviderProps> = ({
  children,
}) => {
  const navigate = useNavigate();
  const { isDark } = useTypedSelector((state) => state.settings);
  const { isAuthenticated } = useTypedSelector((state) => state.auth);
  const [_isAuthenticated, setIsAuthenticated] = useState(isAuthenticated);

  useEffect(() => {
    if (isAuthenticated !== _isAuthenticated) {
      setIsAuthenticated(isAuthenticated);
      if (isAuthenticated) {
        navigate(authorizedStructure.fallbackPath, { replace: true });
      } else {
        navigate(ROUTES.AUTH.LOGIN, { replace: true });
      }
    }
  }, [isAuthenticated]);

  return (
    <Suspense fallback={<AppLoader />}>
      <SharedProvider>
        <WhiteLabelProvider>
          <WhiteLabelLeadProvider>
            <PaymentProviderProvider>
              <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                theme={isDark ? "dark" : "light"}
              />
              {children}
            </PaymentProviderProvider>
          </WhiteLabelLeadProvider>
        </WhiteLabelProvider>
      </SharedProvider>
    </Suspense>
  );
};

export default AppContextProvider;
